export const cleanClass = (str = '') => {
  return str.split(' ').filter(Boolean).join(' ').trim();
};
